import { styled } from 'baseui'
import { FlexColumn } from '@/shared/theme/styled-components'

export const StyledContainer = styled(FlexColumn, {
  width: '100%',
})
